// extracted by mini-css-extract-plugin
export default {"Divider":"_Divider--BQfHv","SolidDivider":"_SolidDivider--PqW4Y"};